// --- Core ---
import {parseISO} from "date-fns";

const parseOptionalISO = (value) => (value ? parseISO(value) : null);

export {
  parseOptionalISO
};
